import { TFunction } from "i18next";

export const HEADER_TRANSLATED_TEXT = (translate: TFunction) => {
  return {
    NAVIGATION_CLOSE_MENU: translate("NAVIGATION_CLOSE_MENU"),
    NAVIGATION_OPEN_MENU: translate("NAVIGATION_OPEN_MENU"),
    NAVIGATION_HOME: translate("NAVIGATION_HOME"),
    NAVIGATION_PROFILE: translate("NAVIGATION_PROFILE"),
    NAVIGATION_LOGIN: translate("NAVIGATION_LOGIN"),
    NAVIGATION_SIGN_UP: translate("NAVIGATION_SIGN_UP"),
  };
};
